import { useEffect, useState } from "react";
import { normalizeImages } from "@/lib/productImages";

/**
 * Editorial product gallery — main image (object-contain on dark fill) + thumbnail strip.
 * Accepts product images as either ['url', ...] or [{url, alt}, ...].
 */
export default function ProductGallery({ images, alt = "" }) {
  const list = normalizeImages(images);
  const [active, setActive] = useState(0);

  useEffect(() => {
    setActive(0);
  }, [images]);

  if (list.length === 0) return null;
  const current = list[active];

  return (
    <div data-testid="product-gallery" className="flex flex-col gap-3">
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#0a0316] ring-1 ring-[#2a1a3a] flex items-center justify-center">
        <img
          src={current.url}
          alt={current.alt || alt}
          className="max-w-full max-h-full object-contain"
          loading="eager"
          draggable={false}
        />
      </div>

      {list.length > 1 && (
        <div
          className="grid gap-2"
          style={{ gridTemplateColumns: `repeat(${Math.min(list.length, 6)}, minmax(0, 1fr))` }}
          data-testid="product-gallery-thumbs"
        >
          {list.map((img, i) => {
            const isActive = i === active;
            return (
              <button
                key={img.url}
                type="button"
                data-testid={`product-gallery-thumb-${i}`}
                onClick={() => setActive(i)}
                aria-label={`View image ${i + 1}`}
                className={`relative aspect-[4/5] overflow-hidden bg-[#0a0316] transition-all duration-200 ${
                  isActive
                    ? "ring-2 ring-[#ff1493]"
                    : "ring-1 ring-[#2a1a3a] hover:ring-[#9d4cdd]/60 opacity-80 hover:opacity-100"
                }`}
              >
                <img
                  src={img.url}
                  alt={img.alt || ""}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  draggable={false}
                />
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
